module.exports = __webpack_public_path__ + "img/logo-sm.ec870c0a.png";